import {
  AbstractApiResponse,
  EngineRequestResultDBData
} from 'vrlcm-gui-types';
import { safeJsonParse } from 'vrlcm-gui-utils';
import { EngineApi } from '../engine';

/*
 * Custom job result data extractor function for marketplace
 */
const extractEngineRequestResultData = <T>(
  engineRequestResultDBData: EngineRequestResultDBData
): T | undefined => {
  return safeJsonParse(engineRequestResultDBData.resultText);
};

export class MPRequestApi {
  public static triggerJobAndReturnResponse = <JD, RD>(
    jobUrl: string,
    jobData: JD,
    postInitFunction?: (cancelFunction: () => void) => void,
    requestType: 'GET' | 'POST' = 'POST'
  ): Promise<AbstractApiResponse<RD>> => {
    return EngineApi.triggerJobAndReturnResponse(
      jobUrl,
      jobData,
      postInitFunction,
      requestType,
      extractEngineRequestResultData
    );
  };
}
